import * as modules from "./modules/";
import config from "../../../../config";
const BrowserNotification = modules[vendor]
  ? modules[vendor]
  : modules["default"];

const { vendor } = config;

export default BrowserNotification;
